import React from "react";


const GalleryPage = () => {
  const galleryImages = [
    { src: "rscc4.jpg", alt: "RSCC Image 4" },
    { src: "rscc2.jpg", alt: "RSCC Image 2" },
    { src: "rce-thumb.jpg", alt: "RCE Thumbnail" },
    { src: "random.jpg", alt: "Random Image" },
    { src: "rscc3.jpg", alt: "RSCC Image 3" },
    { src: "yps-thumb.jpg", alt: "YPS Thumbnail" },
    { src: "WhatsApp Image 2024-12-03 at 10.18.57_be0132f4.jpg", alt: "WhatsApp Image 1" },
    { src: "rscc.jpg", alt: "RSCC Image" },
    { src: "dir_2.jpg", alt: "Directory 2" },
    { src: "rce.jpg", alt: "RCE Image" },
    { src: "dir_3.jpeg", alt: "Directory 3" },
    { src: "rscc4.jpg", alt: "RSCC Image 4" },
    { src: "rscc2.jpg", alt: "School view 2" },
    { src: "rama_logo_2.jpg", alt: "Rama Logo 2" },
    { src: "rscc3.jpg", alt: "School view 1" },
    { src: "ybed-thumb.jpg", alt: "YBED Thumbnail" },
    { src: "rscc2.jpg", alt: "RSCC Image 2" },
    { src: "rps-thumb.jpg", alt: "RPS Thumbnail" },
    { src: "rcn2.jpg", alt: "RCN Image 2" },
    { src: "rcn-thumb.jpg", alt: "RCN Thumbnail" },
    { src: "image-new-2.jpg", alt: "New Image 2" },
    { src: "dir_1.jpg", alt: "Directory 1" },
    { src: "rps-thumb.jpg", alt: "RPS Thumbnail" },
    { src: "rcn.jpg", alt: "RCN Image" },
    { src: "rscc.jpg", alt: "RSCC Image" },
    { src: "rcn2.jpg", alt: "RCN Image 2" },
    { src: "rscc2.jpg", alt: "RSCC Image 2" },
    { src: "WhatsApp Image 2024-12-10 at 15.10.28_508a8e82.jpg", alt: "WhatsApp Image 2" },
    { src: "rce2.jpg", alt: "RCE Image 2" },
    { src: "rscc2.jpg", alt: "RSCC Image 2" },
    { src: "rscc3.jpg", alt: "RSCC Image 3" },
    { src: "image-new-1.jpg", alt: "New Image 1" },
    { src: "rcn2.jpg", alt: "RCN Image 2" }
  ];

  return (
    <div className="gallery-page-container">
      <h1 className="gallery-title">Gallery</h1>
      <p className="gallery-subtitle">Explore our vibrant campus life and activities</p>
      <div className="gallery-grid">
        {galleryImages.map((image, index) => (
          <div key={index} className="gallery-item">
            <img
              src={image.src}
              alt={image.alt || `Gallery image ${index + 1}`}
              className="gallery-image"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GalleryPage;
